import { EMAIL_VERIFY, NEW_PASSWORD } from 'store/auth';
import { POST_CONTACT } from 'store/contactUs';
import { DELETE_ACCOUNT, UPDATE_ACCOUNT } from 'store/settings';
import { CHANGE_PASSWORD } from 'store/settings/types';

export const errorData = [
  POST_CONTACT,
  UPDATE_ACCOUNT,
  DELETE_ACCOUNT,
  CHANGE_PASSWORD,
  // EMAIL_VERIFY,
  NEW_PASSWORD,
];

export const successData = [
  POST_CONTACT,
  UPDATE_ACCOUNT,
  DELETE_ACCOUNT,
  CHANGE_PASSWORD,
  EMAIL_VERIFY,
  NEW_PASSWORD,
];
